webpackJsonp([0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(177);


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./main.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./main.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Tangerine);", ""]);
	
	// module
	exports.push([module.id, ".header{margin:30px}.header>div{display:inline-block}.header img{width:100%}.title-image{opacity:.7;margin-top:20px}.header-left{max-width:60%;width:600px}.header-right{max-width:35%;width:400px;float:right}.playlist{margin:130px auto;max-width:800px}.credits{color:#555;font-family:Tangerine;font-size:25px}.download-link,.download-link:active,download-link:visited{color:#333;cursor:pointer}.download-link:hover{color:#777}.song{margin:5px;padding:10px;border-bottom:1px solid #ccc}.song .info{cursor:pointer}.song .info .icon{font-size:18px;margin:0 7px;color:#555}.song .info .song-title{color:#555;font-family:Tangerine;font-size:45px;vertical-align:middle}.song .p-bar{cursor:pointer;-webkit-transition:all .7s linear;-moz-transition:all .7s linear;-ms-transition:all .7s linear;-o-transition:all .7s linear;width:99%;height:0;background-color:#ddd;margin:0 auto}.song .p-bar .inner-p-bar{width:0;-webkit-transition:all .1s linear;-moz-transition:all .1s linear;-ms-transition:all .1s linear;-o-transition:all .1s linear;background-color:#555;height:100%}.song .p-bar.playing{height:12px;margin:8px auto 14px}.footer{position:fixed;bottom:0;width:100%;background-color:#fff;border-top:1px solid #ccc}.footer .global-info{-webkit-transition:all .5s ease;-moz-transition:all .5s ease;-ms-transition:all .5s ease;-o-transition:all .5s ease;height:0;overflow:hidden}.footer .global-info.playing{height:75px}.footer .global-info .controls-title{color:#555;font-family:Tangerine;font-size:39px;display:inline-block}.footer .global-info .play-controls{font-size:30px;display:inline-block;margin:30px}.footer .global-info .play-controls span{margin:0 10px;cursor:pointer}.footer .global-info .play-controls span:hover{color:#777}.footer .global-info .play-controls span:active{color:#333}.footer .filters{max-width:1100px;width:100%;margin:20px}.footer .filters .filter{font-weight:500;font-family:Tangerine;display:inline-block;margin:0 10px}.footer .filters .filter .filter-title{display:inline-block;font-size:40px}.footer .filters .filter .filter-values{display:inline-block}.footer .filters .filter .filter-values .filter-value{display:inline-block;font-size:23px;margin:0 7px;cursor:pointer;position:relative}.footer .filters .filter .filter-values .filter-value:before{content:\"\";position:absolute;width:100%;height:2px;bottom:0;left:0;background-color:#777;visibility:hidden;transform:scaleX(0);transition:all .3s ease-in-out 0s}.footer .filters .filter .filter-values .filter-value:hover:before{background-color:#777;visibility:visible;transform:scaleX(1)}.footer .filters .filter .filter-values .filter-value.active:before{background-color:#000;visibility:visible;transform:scaleX(1)}", ""]);
	
	// exports


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(8);


/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fdfe98cf151845e35b0059acca1e77da.png";

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "710f2040adadb4b30cecc7b293acc016.png";

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(163);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(164);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Playlist = __webpack_require__(178);
	
	var _Playlist2 = _interopRequireDefault(_Playlist);
	
	var _Footer = __webpack_require__(180);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _superagent = __webpack_require__(168);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	window._ = _lodash2.default;
	
	var Header = _react2.default.createClass({
	  displayName: 'Header',
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'header' },
	      _react2.default.createElement(
	        'div',
	        { className: 'header-left' },
	        _react2.default.createElement('img', { className: 'title-image', src: __webpack_require__(174) }),
	        _react2.default.createElement(
	          'div',
	          { className: 'credits' },
	          'A 6,000 song album made by ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://asdf.us/pepper', target: '_BLANK' },
	            'Pepper'
	          ),
	          ',',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.linkedin.com/in/brandon-winston-3b179951', target: '_BLANK' },
	            ' Brandon'
	          ),
	          ', and ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://cloudonshore.com', target: '_BLANK' },
	            'Sam'
	          ),
	          '.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'header-right' },
	        _react2.default.createElement('img', { src: __webpack_require__(175) })
	      )
	    );
	  }
	});
	
	var limit = 100;
	var offset = 0;
	var done = false;
	
	var filters = {
	  mood: [{ "all": "All" }, { "Major": "😊" }, { "Minor": "😔" }],
	  orchestration: [{ "all": "All" }, { "Strings Concertino": "Strings Concertino" }, { "Strings Tutti": "Strings Tutti" }, { "Strings Pizzicato": "Strings Pizzicato" }],
	  tempo: [{ "all": "All" }, { "Allegro": "Slow" }, { "Lento": "Medium" }, { "Presto": "Fast" }]
	};
	
	var App = _react2.default.createClass({
	  displayName: 'App',
	  getInitialState: function getInitialState() {
	    return {
	      songs: [],
	      mood: "all",
	      orchestration: "all",
	      tempo: "all"
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    this.fetchSongs();
	    window.onscroll = _lodash2.default.throttle(function () {
	      var doc = document.documentElement;
	      var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
	      var _docHeight = document.height !== undefined ? document.height : document.body.offsetHeight;
	      if (_docHeight - top < 2000) {
	        offset += limit;
	        if (!done) {
	          _this.fetchSongs();
	        };
	      }
	    }, 100);
	  },
	  fetchSongs: function fetchSongs() {
	    var _this2 = this;
	
	    _superagent2.default.get('https://s3.amazonaws.com/media.songshark.io/endless_strings/songs_with_id.json').end(function (err, res) {
	      var songs = res.body.map(function (song) {
	        song.playing = false;
	        return song;
	      });
	      if (songs.length === 0) {
	        // Do something when there are no songs
	      } else {
	        _this2.setState({ songs: _this2.state.songs.concat(songs) });
	      }
	    });
	    //  fetchSongs(){
	    //      request
	    //	  .get('https://s3.amazonaws.com/media.songshark.io/endless_strings/songs_with_id.json')
	    //	  .end((err, res)=>{
	    //	     const songs = JSON.parse(res.body).map(song=>{
	    //                song.playing = false;
	    //                return song;
	    //	     })
	    //	     if(songs.length==0){
	    //	      done = true;
	    //	     } else {
	    //	       this.setState({songs: this.state.songs.concat(songs)});
	    //	     }
	    //	  })
	    //        .get('https://endless-strings.com/data/songs')
	    //        .query({ limit: limit, offset: offset })
	    //        .end((err, res)=>{
	    //           const songs = res.body.map(song=>{
	    //                song.playing = false;
	    //                return song;
	    //           }); 
	    //           //console.log(songs);
	    //           if(songs.length==0){
	    //            done = true;
	    //           } else {
	    //              this.setState({songs: this.state.songs.concat(songs)});
	    //           }
	    //        });
	  },
	  playSong: function playSong(id) {
	    var songs = this.state.songs;
	
	
	    var song = _lodash2.default.find(songs, { _id: id });
	    if (song.playing) {
	      song.playing = false;
	    } else {
	      _lodash2.default.each(songs, function (song) {
	        song.playing = false;
	      });
	      song.playing = true;
	    }
	    this.forceUpdate();
	  },
	  changeFilter: function changeFilter(filterName, filterValue) {
	    this.setState(_defineProperty({}, filterName, filterValue));
	  },
	  playNext: function playNext(id) {
	    var songs = this.state.songs;
	
	    var index = _lodash2.default.findIndex(songs, { _id: id });
	    this.playSong(songs[index + 1]._id);
	  },
	  playPrevious: function playPrevious(id) {
	    var songs = this.state.songs;
	
	    var index = _lodash2.default.findIndex(songs, { _id: id });
	    if (index != 0) {
	      this.playSong(songs[index - 1]._id);
	    }
	  },
	  render: function render() {
	    var playNext = this.playNext;
	    var playSong = this.playSong;
	    var playPrevious = this.playPrevious;
	    var changeFilter = this.changeFilter;
	    var _state = this.state;
	    var songs = _state.songs;
	    var mood = _state.mood;
	    var orchestration = _state.orchestration;
	    var tempo = _state.tempo;
	
	    var filteredSongs = filterSongs(songs, mood, orchestration, tempo);
	
	    var playingSong = _lodash2.default.find(songs, { playing: true });
	
	    window.songs = songs;
	    var currentlyPlaying = null;
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(Header, null),
	      _react2.default.createElement(_Playlist2.default, { playNext: playNext, playSong: playSong, songs: filteredSongs }),
	      _react2.default.createElement(_Footer2.default, { playNext: playNext,
	        playPrevious: playPrevious,
	        currentlyPlaying: currentlyPlaying,
	        playSong: playSong,
	        mood: mood,
	        orchestration: orchestration,
	        tempo: tempo,
	        changeFilter: changeFilter,
	        playingSong: playingSong,
	        filters: filters })
	    );
	  }
	});
	
	function filterSongs(songs, mood, orchestration, tempo) {
	  var filters = {};
	  if (mood != "all") {
	    filters["harmonic_key_type"] = mood;
	  }if (orchestration != "all") {
	    filters["orchestral_preset"] = orchestration;
	  }if (tempo != "all") {
	    filters["tempo_classification"] = tempo;
	  }
	  if (_lodash2.default.isEmpty(filters)) {
	    return songs;
	  } else {
	    return _lodash2.default.filter(songs, filters);
	  }
	}
	
	var el = document.getElementById('container');
	var app = _react2.default.createElement(App, null);
	// todo: re-add ga.pageview call for each page load??
	_reactDom2.default.render(app, el);

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(163);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(164);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Song = __webpack_require__(179);
	
	var _Song2 = _interopRequireDefault(_Song);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Playlist = _react2.default.createClass({
	  displayName: 'Playlist',
	  render: function render() {
	    var _props = this.props;
	    var playSong = _props.playSong;
	    var playNext = _props.playNext;
	    var songs = _props.songs;
	
	    var songDivs = songs.map(function (song) {
	      return _react2.default.createElement(_Song2.default, _extends({}, song, { key: song._id, playSong: playSong, onEnd: playNext }));
	    });
	    return _react2.default.createElement(
	      'div',
	      { className: 'playlist' },
	      songDivs
	    );
	  }
	});
	
	exports.default = Playlist;

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(163);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(164);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AudioPlayer = _react2.default.createClass({
	    displayName: 'AudioPlayer',
	    componentDidMount: function componentDidMount() {
	        var _this = this;
	
	        var _props = this.props;
	        var playing = _props.playing;
	        var onProgress = _props.onProgress;
	        var onEnd = _props.onEnd;
	
	        this.el = _reactDom2.default.findDOMNode(this.refs.audio_tag);
	        if (playing) {
	            this.play();
	        }
	        this.el.ontimeupdate = function () {
	            onProgress(_this.el.currentTime / _this.el.duration);
	        };
	        this.el.onended = function () {
	            _this.el.currentTime = 0;
	            onEnd();
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	        var playing = this.props.playing;
	
	        if (newProps.playing && !playing) {
	            this.play();
	        } else if (!newProps.playing && playing) {
	            this.stop();
	        }
	    },
	    play: function play() {
	        this.el.play();
	    },
	    stop: function stop() {
	        this.el.pause();
	    },
	    seekPercent: function seekPercent(percent) {
	        this.el.currentTime = this.el.duration * percent;
	    },
	    render: function render() {
	        var url = this.props.url;
	        //debugger
	
	        return _react2.default.createElement('audio', { ref: 'audio_tag', src: url });
	    }
	});
	
	var Song = _react2.default.createClass({
	    displayName: 'Song',
	    getInitialState: function getInitialState() {
	        return {
	            progress: 0
	        };
	    },
	    onProgress: function onProgress(percent) {
	        this.setState({ progress: percent });
	    },
	    seekProgress: function seekProgress(e) {
	        e.stopPropagation();
	        e.preventDefault();
	        var mouseX = e.clientX;
	
	        var bar = this.refs.p_bar;
	        this.refs.player.seekPercent((mouseX - bar.offsetLeft) / bar.offsetWidth);
	    },
	    onEnd: function onEnd() {
	        var _props2 = this.props;
	        var onEnd = _props2.onEnd;
	        var _id = _props2._id;
	
	        onEnd(_id);
	    },
	    render: function render() {
	        var progress = this.state.progress;
	        var _props3 = this.props;
	        var _id = _props3._id;
	        var title = _props3.title;
	        var url = _props3.url;
	        var playing = _props3.playing;
	        var playSong = _props3.playSong;
	
	        var progressBarStyle = { width: progress * 100 + '%' };
	        var outerProgressBarStyle = playing ? {} : { height: "0px", border: "0px solid #aaa" };
	        return _react2.default.createElement(
	            'div',
	            { className: 'song', key: _id },
	            _react2.default.createElement(
	                'div',
	                { className: 'info', onClick: playSong.bind(null, _id) },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'icon' },
	                    _react2.default.createElement('span', { className: "glyphicon glyphicon-" + (playing ? "pause" : "play") })
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'song-title' },
	                    title
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: "p-bar " + (playing ? "playing" : ""), style: outerProgressBarStyle, onClick: this.seekProgress, ref: 'p_bar' },
	                _react2.default.createElement('div', { className: 'inner-p-bar', style: progressBarStyle })
	            ),
	            playing ? _react2.default.createElement(AudioPlayer, { playing: playing, url: url, onProgress: this.onProgress, ref: 'player', onEnd: this.onEnd }) : null
	        );
	    }
	});
	
	exports.default = Song;

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(163);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(164);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = _react2.default.createClass({
	  displayName: 'Footer',
	  getInitialState: function getInitialState() {
	    return {
	      playingSong: undefined
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (newProps.playingSong) {
	      this.setState({ playingSong: newProps.playingSong });
	    } else if (this.state.playingSong) {
	      var newSong = _lodash2.default.extend({}, this.state.playingSong);
	      newSong.playing = false;
	      this.setState({ playingSong: newSong });
	    }
	  },
	  renderFilters: function renderFilters() {
	    var _props = this.props;
	    var mood = _props.mood;
	    var orchestration = _props.orchestration;
	    var tempo = _props.tempo;
	    var changeFilter = _props.changeFilter;
	    var playNext = _props.playNext;
	    var playPrevious = _props.playPrevious;
	    var playSong = _props.playSong;
	    var filters = _props.filters;
	
	    var settings = { mood: mood, orchestration: orchestration, tempo: tempo };
	    return _lodash2.default.map(filters, function (filterValues, filter) {
	
	      var filterValuesDivs = _lodash2.default.map(filterValues, function (filterValue) {
	        var key = _lodash2.default.first(_lodash2.default.keys(filterValue));
	        return _react2.default.createElement(
	          'div',
	          { className: "filter-value " + (settings[filter] == key ? "active" : ""),
	            onClick: changeFilter.bind(null, filter, key),
	            key: key
	          },
	          _lodash2.default.first(_lodash2.default.values(filterValue))
	        );
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'filter', key: filter },
	        _react2.default.createElement(
	          'div',
	          { className: 'filter-title' },
	          _lodash2.default.capitalize(filter),
	          ':'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'filter-values' },
	          filterValuesDivs
	        )
	      );
	    });
	  },
	  download: function download(url, title) {
	    Download(url, title);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var mood = _props2.mood;
	    var orchestration = _props2.orchestration;
	    var tempo = _props2.tempo;
	    var changeFilter = _props2.changeFilter;
	    var playNext = _props2.playNext;
	    var playPrevious = _props2.playPrevious;
	    var playSong = _props2.playSong;
	    var filters = _props2.filters;
	    var playingSong = this.state.playingSong;
	
	
	    var id = playingSong ? playingSong._id : null;
	    var title = playingSong ? playingSong.title : null;
	    var url = playingSong ? playingSong.url : null;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'footer' },
	      _react2.default.createElement(
	        'div',
	        { className: "global-info " + (playingSong ? "playing" : "") },
	        _react2.default.createElement(
	          'div',
	          { className: 'play-controls' },
	          _react2.default.createElement('span', { className: 'glyphicon glyphicon-backward', onClick: playPrevious.bind(null, id) }),
	          _react2.default.createElement('span', { className: "glyphicon glyphicon-" + (_lodash2.default.get(playingSong, 'playing') ? "pause" : "play"), onClick: playSong.bind(null, id) }),
	          _react2.default.createElement('span', { className: 'glyphicon glyphicon-forward', onClick: playNext.bind(null, id) })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'controls-title' },
	          title,
	          _react2.default.createElement('span', { className: 'download-link glyphicon glyphicon-download',
	            style: { fontSize: '30px', marginLeft: '30px' },
	            onClick: this.download.bind(null, url, title)
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'filters' },
	        this.renderFilters()
	      )
	    );
	  }
	});
	
	exports.default = Footer;
	
	
	function Download(url, fancyFileName) {
	  var file = document.createElement('a');
	  file.href = url;
	  file.target = '_blank';
	  file.download = fancyFileName;
	
	  var event = document.createEvent('Event');
	  event.initEvent('click', true, true);
	  file.dispatchEvent(event);
	  window.URL.revokeObjectURL(file.href);
	}
	
	/*
	                <div className="form-group">
	                    <label>Mood &nbsp;</label>
	                    <div  className="form-control filter" role="group" aria-label="...">
	                      <span className={"filter-value " + (mood=="all"?"active":"")} onClick={changeFilter.bind(null,"mood","all")}> All </span>
	                      <button type="button" className={"btn btn-default " + (mood=="Major"?"active":"")} onClick={changeFilter.bind(null,"mood","Major")}> 😊 </button>
	                      <button type="button" className={"btn btn-default " + (mood=="minor"?"active":"")} onClick={changeFilter.bind(null,"mood","minor")}> 😔  </button>
	                    </div>
	                </div>
	                <div className="form-group">
	                    <label>Orchestration &nbsp;</label>
	                    <div  className="form-control" className="btn-group" role="group" aria-label="...">
	                      <button type="button" className={"btn btn-default " + (orchestration=="all"?"active":"")} onClick={changeFilter.bind(null,"orchestration","all")}>All</button>
	                      <button type="button" className={"btn btn-default " + (orchestration=="Strings Concertino"?"active":"")} onClick={changeFilter.bind(null,"orchestration","Strings Concertino")}>Strings Concertino</button>
	                      <button type="button" className={"btn btn-default " + (orchestration=="Strings Tutti"?"active":"")} onClick={changeFilter.bind(null,"orchestration","Strings Tutti")}>Strings Tutti</button>
	                      <button type="button" className={"btn btn-default " + (orchestration=="Strings Pizzicato"?"active":"")} onClick={changeFilter.bind(null,"orchestration","Strings Pizzicato")}>Strings Pizzicato</button>
	                    </div>
	                </div>
	                <div className="form-group">
	                    <label>Tempo &nbsp;</label>
	                    <div  className="form-control" className="btn-group" role="group" aria-label="...">
	                      <button type="button" className={"btn btn-default " + (tempo=="all"?"active":"")} onClick={changeFilter.bind(null,"tempo","all")}>All</button>
	                      <button type="button" className={"btn btn-default " + (tempo=="Allegro"?"active":"")} onClick={changeFilter.bind(null,"tempo","Allegro")}>Allegro</button>
	                      <button type="button" className={"btn btn-default " + (tempo=="Lento"?"active":"")} onClick={changeFilter.bind(null,"tempo","Lento")}>Lento</button>
	                      <button type="button" className={"btn btn-default " + (tempo=="Presto"?"active":"")} onClick={changeFilter.bind(null,"tempo","Presto")}>Presto</button>
	                    </div>
	                </div>
	                */

/***/ })

});


// WEBPACK FOOTER //
// scripts/app.2551afc.js